// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3RCfv","rootSuccess":"CompleteLink_rootSuccess__U2QGf","rootFailure":"CompleteLink_rootFailure__2vOGK","isDisabled":"CompleteLink_isDisabled__asY6Q"};